export default __webpack_public_path__ + "static/media/EM0333.34I-41689_-24987_0.889a501d.jpg";